module.exports = __webpack_public_path__ + "static/img/map4.8f5c2f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map/map4.png
// module id = ZX1h
// module chunks = 0